import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import Button from '../../atoms/Buttons'
import FormInput from '../../atoms/Input/Form-Input'
import MailIcon from '../../../assets/icons/mail.svg'
import LockIcon from '../../../assets/icons/lock.svg'
import { FiEyeOff, FiEye } from 'react-icons/fi'
import {
  fetchAuthSession,
  signIn,
  confirmSignIn,
  signOut,
} from 'aws-amplify/auth'
import './style.css'
import { useUserContext } from '../../../context/UserContext'
import LoginModal from '../../../components/atoms/Modal/LoginModal/LoginModal'
import MessageModal from '../../atoms/Modal/MessageModal/MessageModal'
import { equalTo, messages } from '../../../utils/validationErrorMessages'
import { compileTemplate } from '../../../utils'
import { useLazyQuery } from '@apollo/client'
import { GET_MANUFACTURE } from '../../../apollo/queries/getManufacture'

const Login = () => {
  const methods = useForm({})
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [getManufacture] = useLazyQuery(GET_MANUFACTURE)
  const [isConfirmSignUpShow, setIsConfirmSignUpShow] = useState(null)
  const {
    user,
    userLoading,
    setOpenModal,
    fetchUser,
    modalState,
    openMessageModal,
    closeMessageModal,
    setAuthLoading,
  } = useUserContext()
  const [showPassword, setShowPassword] = useState(false)
  const [needsNewPassword, setNeedsNewPassword] = useState(false)

  const onHandleSignIn = async data => {
    let stripeRedirecting = false

    try {
      setLoading(true)
      setOpenModal(true)

      const { nextStep } = await signIn({
        username: data.username,
        password: data.password,
      })

      console.log({ nextStep })

      if (
        nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
      ) {
        setNeedsNewPassword(true)
        return
      }

      const { tokens } = await fetchAuthSession()
      const rawGroups =
        tokens?.idToken?.payload?.['cognito:groups'] ??
        tokens?.idToken?.payload?.['custom:userType']

      const groups = Array.isArray(rawGroups)
        ? rawGroups.filter(g => typeof g === 'string' && g)
        : typeof rawGroups === 'string'
          ? rawGroups
          : ''

      const email = tokens?.idToken?.payload?.email
      const brandName = tokens?.idToken?.payload?.['custom:manufacturer']
      const signedInGroup = Array.isArray(groups) ? groups[0] : groups
      console.log('brandName', brandName)

      localStorage.setItem('isSignedIn', signedInGroup)
      localStorage.setItem('email', email)
      localStorage.setItem('brand', brandName)

      await fetchUser()

      if (signedInGroup && email) {
        const { data } = await getManufacture({ variables: { email } })
        console.log('getManufacture data:', data)

        if (
          brandName !== 'cactus' &&
          data?.getManufacturer[0]?.manufacturerObject?.isBusinessInfo === false &&
          data?.getManufacturer[0]?.manufacturerObject?.brand !== 'saddlefitadmin'
        ) {
          navigate('/onboarding', { replace: true })
          return
        }

        if (
          brandName !== 'cactus' &&
          !data?.getManufacturer[0]?.manufacturerObject?.isShopifyConnected &&
          data?.getManufacturer[0]?.manufacturerObject?.brand !== 'saddlefitadmin'
        ) {
          navigate('/shopify-connect', { replace: true, state: { brandName } })
          return
        }

        if (
          brandName !== 'cactus' &&
          data?.getManufacturer[0]?.manufacturerObject?.isStripeConnected === false &&
          data?.getManufacturer[0]?.manufacturerObject?.brand !== 'saddlefitadmin'
        ) {
          const idToken = tokens.idToken?.toString()
          const resp = await fetch(import.meta.env.VITE_STRIPE_VALIDATE_URL, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })

          const { stripeConnectUrl } = await resp.json()
          console.log('stripeConnectUrl', stripeConnectUrl)

          stripeRedirecting = true
          setAuthLoading(false)
          window.location.href = stripeConnectUrl
          return
        }
      } else {
        await signOut()
        openMessageModal('Access Denied', "Oops! You don't have Admin Access.")
      }
    } catch (error) {
      openMessageModal(
        'Error',
        error?.message || 'An error occurred during sign-in.',
      )
    } finally {
      setOpenModal(false)
      setLoading(false)
      if (!stripeRedirecting) {
        setAuthLoading(false)
      }
    }
  }

  const onHandleNewPassword = async data => {
    let stripeRedirecting = false

    try {
      setAuthLoading(true)

      const { tokens } = await fetchAuthSession()
      const givenName = tokens?.idToken?.payload?.given_name || tokens?.idToken?.payload?.name?.split(' ')[0] || 'User'
      const familyName = tokens?.idToken?.payload?.family_name || tokens?.idToken?.payload?.name?.split(' ').slice(1).join(' ') || 'Name'

      const userAttributes = {}
      if (givenName && givenName?.trim()) {
        userAttributes.given_name = givenName?.trim()
      }
      if (familyName && familyName?.trim()) {
        userAttributes.family_name = familyName?.trim()
      }

      await confirmSignIn({
        challengeResponse: data.newPassword,
        options: {
          userAttributes: Object.keys(userAttributes)?.length > 0 ? userAttributes : undefined,
        },
      })

      const { tokens: newTokens } = await fetchAuthSession()
      const rawGroups =
        newTokens?.idToken?.payload?.['cognito:groups'] ??
        newTokens?.idToken?.payload?.['custom:userType']

      const groups = Array.isArray(rawGroups)
        ? rawGroups.filter(g => typeof g === 'string' && g)
        : typeof rawGroups === 'string'
          ? rawGroups
          : ''

      const email = newTokens?.idToken?.payload?.email
      const brandName = newTokens?.idToken?.payload?.['custom:manufacturer']
      const signedInGroup = Array.isArray(groups) ? groups[0] : groups

      localStorage.setItem('isSignedIn', signedInGroup)
      localStorage.setItem('email', email)
      localStorage.setItem('brand', brandName)

      await fetchUser()

      if (signedInGroup && email) {
        const { data } = await getManufacture({ variables: { email } })

        if (brandName !== 'cactus' && data?.getManufacturer[0]?.manufacturerObject?.isBusinessInfo === false && data?.getManufacturer[0]?.manufacturerObject?.brand !== "saddlefitadmin") {
          navigate('/onboarding', { replace: true })
          return
        }

        if (brandName !== 'cactus' && data?.getManufacturer[0]?.manufacturerObject?.isShopifyConnected === false && data?.getManufacturer[0]?.manufacturerObject?.brand !== "saddlefitadmin") {
          navigate('/shopify-connect', { replace: true, state: { brandName } })
          return
        }

        if (brandName !== 'cactus' && data?.getManufacturer[0]?.manufacturerObject?.isStripeConnected === false && data?.getManufacturer[0]?.manufacturerObject?.brand !== "saddlefitadmin") {
          const idToken = newTokens.idToken?.jwtToken
          const resp = await fetch(import.meta.env.VITE_STRIPE_VALIDATE_URL, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${idToken}`,
            },
          })

          const { stripeConnectUrl } = await resp.json()
          stripeRedirecting = true
          setAuthLoading(false)
          window.location.href = stripeConnectUrl
          return
        }
      } else {
        await signOut()
        openMessageModal('Access Denied', "Oops! You don't have Admin Access.")
      }
    } catch (error) {
      openMessageModal('Error', error?.message || 'Password update failed.')
    } finally {
      if (!stripeRedirecting) {
        setAuthLoading(false)
      }
    }
  }

  const renderPasswordResetForm = () => (
    <form
      onSubmit={methods.handleSubmit(onHandleNewPassword)}
      className="w-full h-screen flex justify-center items-center bg-[#F7F7F6]"
    >
      <div className="w-[500px] bg-[#fff] rounded-xl p-10">
        <h2 className="saddlefit-admin-forgotpassword">Change Password</h2>
        <FormInput
          name="newPassword"
          label="New Password"
          type="password"
          placeholder="New Password"
          validations={{
            minLength: {
              value: 8,
              message: 'Password must be at least 8 characters long',
            },
            maxLength: {
              value: 20,
              message: 'Password cannot exceed 20 characters',
            },
            required: 'Password is required',
          }}
        />

        <FormInput
          name="repeatPassword"
          label="Enter New Password Again"
          type="password"
          placeholder="Enter New Password Again"
          validations={{
            equalTo: equalTo(
              'newPassword',
              compileTemplate(messages.equalTo, { attribute: 'newPassword' }),
            ),
            required: 'Please confirm your password',
          }}
          className="mt-4"
        />

        <div className="mt-6 flex justify-center">
          <Button
            type="submit"
            className="modal_form_btn"
            primary
            loading={userLoading}
          >
            Save
          </Button>
        </div>
      </div>
    </form>
  )

  const renderLoginForm = () => (
    <form onSubmit={methods.handleSubmit(onHandleSignIn)}>
      <div className="w-full h-[100vh] flex justify-center items-center bg-[#F7F7F6]">
        {!user && (
          <div className="register-modal-content w-[90%] sm:w-[516px] h-auto rounded-xl bg-[#fff]">
            <h3 className="saddlefit-admin">SaddleFit Admin</h3>
            <div className="register-content w-[90%] mx-auto">
              <div className="register-content-form">
                <FormInput
                  label={'Username'}
                  icon={MailIcon}
                  name="username"
                  autoComplete="off"
                  validations={{
                    required: 'Username is required',
                    pattern: { message: 'Username is required' },
                  }}
                  placeholder={'username'}
                />
                <div className="relative">
                  <FormInput
                    className="register-content-form__field mt-[29.66px]"
                    label={'Password'}
                    icon={LockIcon}
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    placeholder={'Enter password'}
                    validations={{
                      required: 'Password is required',
                      pattern: { message: 'Password is required' },
                    }}
                  />
                  {showPassword ? (
                    <FiEye
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute top-3 right-4 w-6 h-6"
                    />
                  ) : (
                    <FiEyeOff
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute top-3 right-4 w-6 h-6"
                    />
                  )}
                </div>
              </div>
              <div className="register-content-submit mb-10 flex justify-center flex-col items-center mt-[22px] ">
                <Button
                  type="submit"
                  loading={userLoading}
                  className={'modal_form_btn cursor-pointer'}
                  primary
                >
                  Login
                </Button>
                <span className={'register-content-submit__text'}>
                  Forgot password?{' '}
                  <Link
                    to={'/forgot-password'}
                    className={'font-bold underline text-primary'}
                  >
                    Click here
                  </Link>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </form>
  )

  return (
    <FormProvider {...methods}>
      {needsNewPassword
        ? renderPasswordResetForm()
        : isConfirmSignUpShow !== null
          ? renderConfirmSignUpForm()
          : renderLoginForm()}

      {loading && (
        <LoginModal
          title="Loading CMS..."
          description="Sit back tight, your dashboard is loading in few seconds."
        />
      )}

      {modalState?.isOpen && (
        <MessageModal
          title={modalState.title}
          description={modalState.message}
          showModal={modalState.isOpen}
          onClose={closeMessageModal}
        />
      )}
    </FormProvider>
  )
}

export default Login
